<template>
  <div class="repair-order-info app-region blank-t-v blank-b-v blank-l-h blank-r-h">
    <a-form-model class="app-form" ref="form" :model="form" :rules="rules" :labelCol="$formLabelCol" :wrapperCol="$formWrapperCol">
      <a-form-model-item label="报修项目" prop="project">
        <a-cascader v-model="form.project" :options="projectOptions" placeholder="请选择报修项目"></a-cascader>
      </a-form-model-item>
      <a-form-model-item label="报修位置" prop="position" v-if="form.project[0] === 1">
        <a-input v-model="form.position" placeholder="请输入报修位置" allow-clear></a-input>
      </a-form-model-item>
      <template v-if="form.project[0] === 2">
        <a-form-model-item label="报修位置" prop="house">
          <div>
            <a-button type="primary" @click="showModal">选择</a-button>
          </div>
          <div>
            <a-tag class="large" closable @close.prevent="delHouse(index)" v-for="(value, index) in form.house" :key="index">{{value.full_name}}</a-tag>
          </div>
        </a-form-model-item>
        <a-form-model-item label="上门时间" prop="time">
          <a-select v-model="form.time" placeholder="请选择上门时间">
            <a-select-option :value="value.value" v-for="value in timeOptions" :key="value.value">{{value.name}}</a-select-option>
          </a-select>
        </a-form-model-item>
      </template>
      <a-form-model-item label="问题描述" prop="note">
        <a-textarea v-model="form.note" placeholder="请输入问题描述"></a-textarea>
      </a-form-model-item>
      <a-form-model-item label="报修图片" prop="avatar">
        <a-upload name="media" list-type="picture-card" :action="$uploadUrl" class="app-avatar-uploader" :before-upload="$beforeUpload" @change="handleChange" :file-list="form.avatar">
          <a-icon type="plus" v-if="form.avatar.length < 9"></a-icon>
        </a-upload>
      </a-form-model-item>
      <a-form-model-item :wrapper-col="$formEmptyLabelWrapperCol">
        <a-space>
          <a-button type="primary" @click="submit">提交</a-button>
          <a-button @click="cancel">取消</a-button>
        </a-space>
      </a-form-model-item>
    </a-form-model>
    <a-modal :title="modal.title" v-model="modal.show" @ok="confirmModal" destroy-on-close width="60%" centered>
      <tree-select v-model="modal.house" :data="tree.data" :params="tree.params" :load-data="$houseTreeData" @load="loadTreeSelectNode"></tree-select>
    </a-modal>
  </div>
</template>

<script>
  import RepairItemsService from '@/io/repair_items.js';
  import RepairOrderService from '@/io/repair_order.js';

  export default {
    name: 'RepairOrderInfo',
    data() {
      return {
        communityId: this.$route.query.community_id || this.$getCookie('communityId'),
        projectOptions: [],
        timeOptions: [],
        form: {
          project: [],
          position: null,
          house: [],
          time: [],
          note: null,
          avatar: []
        },
        rules: {
          project: [
            {
              required: true,
              message: '请选择报修项目'
            }
          ],
          position: [
            {
              required: true,
              message: '请填写报修位置'
            }
          ],
          house: [
            {
              required: true,
              message: '请选择报修位置'
            }
          ],
          time: [
            {
              required: true,
              message: '请选择上门时间'
            }
          ],
          note: [
            {
              required: true,
              message: '请填写问题描述'
            }
          ]
        },
        tree: {
          data: [],
          params: {
            children: 'children',
            title: 'name',
            key: '_id'
          }
        },
        modal: {
          title: '选择房屋',
          show: false,
          house: []
        },
      }
    },
    mounted () {
      this.initProject();
      this.initTime();
      this.initTreeData();
    },
    methods: {
      loadTreeSelectNode(data) {
        data.children.forEach(val => {
          this.$set(val, 'disabled', val.level <= 3);
        });
      },
      confirmModal() {
        this.modal.show = false;
        this.form.house = this.$createNewVariable(this.modal.house);
      },
      showModal() {
        this.modal.show = true;
        this.modal.house = this.$createNewVariable(this.form.house);
      },
      delHouse(index) {
        this.form.house.splice(index, 1);
      },
      initTreeData() {
        return this.$houseTreeData([], [1, 4], this.communityId).then(res => {
          this.tree.data = res.map(val => {
            val.disabled = true;
            return val;
          });
        });
      },
      initProject() {
        let projectOptions = []; 
        return RepairItemsService.type().then(res => {
          projectOptions = res.repair_types.map(val => {
            val.label = val.name;
            val.children = [];
            return val;
          });
          return RepairItemsService.list(this.communityId);
        }).then(res => {
          projectOptions.forEach((value, index) => {
            value.children = res.filter(val => val.repair_item_type === value.value).map(val => {
              val.label = val.repair_item_name;
              val.value = val.repair_items_id;
              val.parentId = value.value;
              return val;
            });
          });
          this.projectOptions = projectOptions.filter(val => val.children.length);
        }).catch(err => {});
      },
      handleChange(info) {
        let status = info.file.status;
        if (status) {
          this.form.avatar = info.fileList.map(val => {
            return {
              uid: val.uid,
              name: val.name,
              status: val.status,
              url: val.url || (val.response ? val.response.media : null)
            }
          });
        }
      },
      initTime() {
        return RepairOrderService.timeList().then(res => {
          let time = [];
          res.service_datetime.forEach(val => {
            val.times.forEach(m => {
              time.push({
                name: `${val.date} ${m.value}`,
                value: `${val.date} ${m.time}:00`
              })
            });
          });
          this.timeOptions = time;
        }).catch(err => {});
      },
      submit() {
        this.$beforeFormSubmit(this.$refs.form, () => {
          RepairOrderService.add(
            this.communityId,
            this.form.project[0],
            this.form.project[1],
            this.form.position,
            this.form.house.length ? this.form.house[0].id : null,
            this.form.time,
            this.form.note,
            this.form.avatar.map(val => val.url)
          ).then(res => {
            this.$afterFormSubmit('创建成功', () => {
              this.cancel();
            });
          }).catch(err => {});
        });
      },
      cancel() {
        this.$router.push({
          name: 'RepairOrder'
        });
      }
    },
  }
</script>

<style lang="less" scoped>

</style>